/** Implement support for W3C Trace Context header
 *
 */

/** Generate random hex string
 * @param size how many bytes generate
 *
 * @return string
 */
export function getRendomHexString(size) {

    if (!size || size <= 0) size = 8;

    // prepare buffer
    const u8array = new Uint8Array(size);

    // fill buffer with random numbers
    crypto.getRandomValues(u8array);

    // format as hex and return as string
    return Array.from(u8array, x => x.toString(16).padStart(2, '0')).join('');
}

/** Generate traceId - an unique id of user session
 *
 * @return 32 bytes long hex string
 */
export function getTraceId() {
    return getRendomHexString(16);
}

/** Generate parentId - an unique id for each API request
 *
 * @return 16 bytes long hex string
 */
export function getParentId() {
    return getRendomHexString(8);
}

/** Return formated traceparent string
 * @param traceId   session ID
 * @param parentId  request ID
 *
 * @return formated traceparent string: 00-traceId-parentId-00
 */
export function formatTraceParent(traceId, parentId) {
    return ['00', traceId, parentId, '00'].join('-');
}
